import { Pipe, PipeTransform } from '@angular/core';
import {
  isQuoteStatusAfterOrEqual,
  Quote,
  QUOTE_STATUSES,
  QuoteStatus,
} from '@lockton-apps/shared/interfaces';
import { find } from 'lodash';

export type QuoteDetails = Record<
  'proposal' | 'quote' | 'payment',
  Record<string, any>
>;

@Pipe({
  name: 'renewalStatusHistory',
  standalone: true,
})
export class RenewalStatusHistoryPipe implements PipeTransform {
  transform(quote: Quote): QuoteDetails {
    return {
      proposal: {
        sentToClient: this.getTimestamp(quote, QUOTE_STATUSES.FormSent),
        lastUpdated: this.getTimestamp(quote, QUOTE_STATUSES.FormIncomplete),
      },
      quote: {
        sentToClient: this.getTimestamp(quote, QUOTE_STATUSES.BrokerApproved),
        clientAccepted: this.getTimestamp(quote, QUOTE_STATUSES.QuoteAccepted),
      },
      payment: {
        invoiceSent: this.getTimestamp(quote, QUOTE_STATUSES.AwaitingPayment),
        invoicePaid: this.getTimestamp(quote, QUOTE_STATUSES.Complete),
      },
    };
  }

  private getTimestamp(quote: Quote, startFrom?: QuoteStatus): string | void {
    if (!startFrom || isQuoteStatusAfterOrEqual(quote.status, startFrom)) {
      return find(quote.statusHistory, { status: quote.status })?.timestamp;
    }
  }
}
